import React from 'react';
import { Helmet } from 'react-helmet';
import ScopeOfWork from 'components/Preference/ScopeOfWork';

// Settings > Scope of work templates (/preferences/scope_of_work_templates).
// The templates load themselves (components/Preference/ScopeOfWork.js).
const ScopeOfWorkTemplatesPage = () => (
  <React.Fragment>
    <Helmet>
      <title>Scope of work templates | FieldNexus</title>
    </Helmet>
    <ScopeOfWork />
  </React.Fragment>
);

export default ScopeOfWorkTemplatesPage;
